import React, { useRef, useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import ReportsService from '../../services/reports.service'
import {
  Observations,
  LoaderWrapper,
  ReportEditHeader,
  DownloadExcel,
  DownloadCSV,
  DownloadDoc,
  InsightsRteContent,
  MuiButton,
  MuiButtons,
} from '../../components'
import { Box, Menu, IconButton } from '@mui/material'
import { Insights, Menu as MenuIcon } from '@mui/icons-material'
// import { useReactQuery, useReactQueryRefetch } from '../../hooks'
import { useExportToPptObjects, useReactQuery } from '../../hooks'

import { ROLES_CLIENT_SECONDARY, ROLES_MM_PRIMARY , IS_SCREEN_BELOW_1280 } from '../../constants'
import { scrollByPxFromCurrentPosition } from '../../util'
import {
  IconArrowLeft,
  IconArrowSort,
  Download,
  IconWord,
  IconExport,
  ArrowDown,
  IconArrowOutlineDown,
} from '../../assets/images/icons'
import { IconObservations, IconInsights, IconClose } from '../../assets/images/iconsV2'
import { useGlobalStore } from '../../store'
import ProgressionDropdown from './progressionDropdown'
import decode from 'unescape'

import {
  HeadingOuterWrapper,
  HeadingInnerWrapper,
  SubHeading,
  CardHeading,
  ContentWrapper,
  CardRteContent,
  ButtonBox,
  InsightsOuterWrapper,
  ButtonPlaceHolder,
  ButtonUp,
  ButtonDown,
  MenuIconButton,
  InsightsInnerWrapper,
  SlideOverlay,
  ExportButtonsWrapper,
  ExportWrapper,
  MenuOuterWrapper,
  MenuInnerWrapper,
  MenuHeading,
} from './style'
import { getLogData, removeHtmlTags } from '../../util'

const ReportHeading = (props) => {
  const {
    moveInsightsTo,
    resetInsightHeight,
    downloadId,
    wordDocData,
    Heading,
    subHeading,
    InsightsElementId,
    InsightsElementType,
    showObservations = true,
    additionalButton,
    additionalMiddleButton,
    onSuccess,
    addTable = false,
    afterHeadingComponent,
    onInsightsChange,
    graphBtn=false,
    pptData,
    Title,
    customInsightsData,
    progressionDropdownData,
    progressionDropdownEvents,
    prismData
  } = props

  const {
    user,
    projectIdValue,
    isPPTModalActive,
    isCSVModalActive,
    isAskIaActiveState,
    setAskIaActiveState,
    isFullScreen,
  } = useGlobalStore()

  const { updatingExportToPptObject } = useExportToPptObjects();
  const [loading, setLoading] = useState(false)
  const [pageHeading, setPageHeading] = useState()
  const [pageInsights, setPageInsights] = useState()
  const [pageHeadingData, setPageHeadingData] = useState(false)
  const [pageInsightsData, setPageInsightsData] = useState(false)
  const [hamburgerMenu, showHamburgerMenu] = useState(false)
  const [hamburgerMenuAnchorEl, showHamburgerMenuAnchorEl] = useState(null)

  // Adding Data in the ppt Object
  useEffect(() => {
    if (pptData) {
      let obj = { 
        [downloadId] : JSON.stringify({ Heading:removeHtmlTags(Heading || Title || ''), Title , subHeading , downloadId , ...pptData })
      }
      updatingExportToPptObject(obj)
    }
  } , [])

  const removingTags = (str) => {
    let d1 = str
    if (isPPTModalActive && downloadId?.length > 5) {
      const id = `reportHeadingRteInsights__${downloadId}`
      if (document?.getElementById(id)?.innerHTML) {
        const htmlNode = document?.querySelectorAll(`#${id} *`) || null
        if (isNaN(htmlNode)) {
          for (let i = 0; i < htmlNode.length; i++) {
            htmlNode[i].removeAttribute('style')
          }
          const htmlStr = document
            .getElementById(id)
            .innerHTML.replaceAll('<ol', '<ul')
            .replaceAll('</ol>', '</ul>')
          document.getElementById(id).innerHTML = htmlStr
        }
      }
    }
    return d1
  }

  const loadHeadingData = useCallback(
    (getLatest = false) => {
      // Avoid API call if prismData is present
      if (prismData) {
        setPageHeading(decode(prismData?.Title) || Heading)
        setPageHeadingData(true)
        setLoading(false)
        return
      }

      setLoading(true)
      ReportsService.reportGetHeaderApi({ insightsElementId: InsightsElementId }, getLatest)
        .then((resp) => {
          setPageHeading(decode(resp) || Heading)
          setPageHeadingData(true)
          setLoading(false)
        })
        .catch((error) => {
          const resMessage = error
          console.log('ERROR : ', resMessage)
          setLoading(false)
        })
    },
    [Heading, InsightsElementId, prismData]
  )

  const loadInsightsData = useCallback(
    (getLatest = false) => {
      // Avoid API call if prismData is present
      if (prismData) {
        setPageInsights(decode(prismData?.Heading))
        setPageInsightsData(true)
        return
      }

      ReportsService.reportGetInsightsApi({ insightsElementId: InsightsElementId }, getLatest)
        .then((resp) => {
          setPageInsights(decode(resp))
          setPageInsightsData(true)
        })
        .catch((error) => {
          const resMessage = error
          console.log('ERROR : ', resMessage)
        })
    },
    [InsightsElementId, prismData]
  )

  const onSuccessEdit = () => {
    loadHeadingData(true)
    loadInsightsData(true)
  }

  const showHamburderMenu = (event) => {
    showHamburgerMenuAnchorEl(event.currentTarget)
    showHamburgerMenu(!hamburgerMenu)
  }

  const backToAskIaLandingPage = () => {
    setAskIaActiveState('active')
  }

  const closeAskIaDetailPage = () => {
    setAskIaActiveState('none')
  }

  const onInsightsChangeFunc = (param) => {
    if (
      [
        'BrandAttributeMapElement',
        'BrandAttributeMapAndProgression',
        'TriangulationMapElement',
        'TriangulationMapAndProgression',
        'TriangulationMapElementLog10',
        'TriangulationMapAndProgressionLog10',
      ].includes(InsightsElementType)
    ) {
      onInsightsChange(param)
    }
  }

  const onLoadFocusComponent = () => {
    if (pageHeading) {
      setTimeout(() => {
        if (
          window.location?.hash?.replaceAll('#', '').replaceAll('%20', '')?.split('_')?.[0] ===
          removeHtmlTags(pageHeading.replaceAll(' ', ''))
        ) {
          const position = document.getElementById(`reportHeadingRte__${downloadId}`)
          document.querySelector('.rhsContent').scrollTo({
            top: position ? position.getBoundingClientRect().top - 100 : 0,
            behavior: 'smooth',
          })
        }
      }, 500)
    }
  }

  useEffect(() => {
    if (prismData) {
      setPageHeading(decode(prismData?.Title) || Heading)
      setPageHeadingData(true)
      setPageInsights(decode(prismData?.Heading))
      setPageInsightsData(true)
      setLoading(false)
    } else if (!pageHeading) {
      loadHeadingData()
      loadInsightsData()
    }
    onLoadFocusComponent()
  }, [pageHeading, loadHeadingData, loadInsightsData, prismData])

  useEffect(() => {
    if (props?.askIa) {
      // THIS IS SPECIALLY FOR ASKIA DETAIL SECTION
      loadHeadingData(true)
      loadInsightsData(true)
    }
  }, [props?.askIa])

  return (
    <>
      <HeadingOuterWrapper className=''>
        <LoaderWrapper loading={loading}>
          <HeadingInnerWrapper className='reportHeading'>
            <CardHeading>
              <Box style={{ display: 'flex', flexDirection: 'column' }}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <ContentWrapper
                    className='headingRte'
                    data-title={props.Title}
                    data-parentTitle={props.ParentTitle}
                    data-parentTitleIndex={props.ParentTitleIndex}
                    id={`reportHeadingRte__${downloadId}`}
                    dangerouslySetInnerHTML={{ __html: pageHeading }}
                  ></ContentWrapper>
                  <>
                    {afterHeadingComponent}
                    {user && (!prismData) &&
                      pageHeadingData &&
                      ROLES_MM_PRIMARY.includes(user?.UserType) &&
                      !projectIdValue?.IsFreezed && (
                        <ReportEditHeader
                          pageInsights={pageInsights}
                          pageHeading={pageHeading}
                          InsightsElementId={InsightsElementId}
                          onSuccess={onSuccessEdit}
                          addTable={addTable}
                        />
                      )}
                  </>
                </Box>
                {subHeading && <SubHeading>{subHeading}</SubHeading>}
              </Box>
            </CardHeading>

            <ButtonsSection
              InsightsElementId={InsightsElementId}
              downloadId={downloadId}
              wordDocData={wordDocData}
              additionalButton={additionalButton}
              progressionDropdownData={progressionDropdownData}
              progressionDropdownEvents={progressionDropdownEvents}
              additionalMiddleButton={additionalMiddleButton}
              pageHeading={pageHeading}
              isCSVModalActive={isCSVModalActive}
              pageInsights={pageInsights}
              graphBtn={graphBtn}
              showObservations={showObservations}
              customInsightsData={customInsightsData}
              {...props}
            />
          </HeadingInnerWrapper>
        </LoaderWrapper>

        <LoaderWrapper loading={loading}>
          {((isPPTModalActive && !!pageInsights?.length) || moveInsightsTo === 'moveInsightsToLeft') && (
            <CardRteContent
              id={`reportHeadingRteInsights__${downloadId}`}
              dangerouslySetInnerHTML={{ __html: pageInsights }}
            ></CardRteContent>
          )}
        </LoaderWrapper>
      </HeadingOuterWrapper>
      {((!isFullScreen && !isCSVModalActive && !isPPTModalActive && !!pageInsights?.length && moveInsightsTo === 'moveInsightsToRight') || customInsightsData?.length) && (
        <InsightsContent
          downloadId={downloadId}
          pageInsights={customInsightsData || pageInsights}
          resetInsightHeight={resetInsightHeight}
          onInsightsChange={onInsightsChangeFunc}
        />
      )}
    </>
  )
}

export default ReportHeading

const ExportButton = (props) => {
  const { wordDocData, downloadId, downloadIdData, excel, pageHeading, studyDetails } = props
  const [showMenu, setShowMenu] = useState(false)
  const showExcelWord = wordDocData && excel

  return (
    <ExportButtonsWrapper>
      {showExcelWord ? (
        <MuiButton
          variant='outlined'
          color='light'
          sx={{ marginLeft: '15px' }}
          startIcon={<IconExport />}
          endIcon={<IconArrowOutlineDown />}
          onClick={() => setShowMenu(!showMenu)}
          className={`BtnExport ${showMenu ? 'active' : ''}`}
        >
          Export
        </MuiButton>
      ) : (
        <DownloadExcel
          downloadId={downloadId}
          downloadIdData={downloadIdData}
          buttonName='Export'
          {...props}
        />
      )}
      {showMenu && (
        <ExportWrapper className='mui-multi-button'>
          {wordDocData && (
            <DownloadDoc
              buttonText='Word Document'
              startIcon={<IconWord />}
              downloadData={wordDocData}
              pageHeading={pageHeading}
              studyDetails={studyDetails}
            />
          )}
          {excel && (
            <DownloadExcel
              downloadId={downloadId}
              downloadIdData={downloadIdData}
              buttonName='Excel Document'
              {...props}
            />
          )}
        </ExportWrapper>
      )}
    </ExportButtonsWrapper>
  )
}

const ButtonsSection = (props) => {
  const {
    additionalButton,
    progressionDropdownData,
    progressionDropdownEvents,
    additionalMiddleButton,
    downloadId,
    wordDocData,
    InsightsElementId,
    downloadIdData,
    excel = true,
    pageHeading,
    pageInsights,
    graphBtn = false,
    showObservations,
    customInsightsData,
    prismData
  } = props

  const { user, projectIdValue, isFullScreen } = useGlobalStore()

  const headerLogData = projectIdValue.ProjectId
    ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: projectIdValue.ProjectId })[0]
    : {}

  const studyDetails = {
    studyId: projectIdValue.StudyId,
    brandName: headerLogData?.BrandName || headerLogData?.CategoryName,
    breadCrumb: headerLogData?.ProjectType,
    projectType: `${headerLogData?.ProjectType}, ${headerLogData?.MarketName}`,
    subTitle: projectIdValue.Period,
    logoBase64: projectIdValue.logoBase64
  }

  if (excel && props.isCSVModalActive) {
    return <DownloadExcel downloadId={downloadId} downloadIdData={downloadIdData} {...props} />
  } else {
    return (
      <ButtonBox className={`buttonList ${graphBtn ? "graphBtn-tutorial" : ""}`}>
        {additionalButton}
        {progressionDropdownData?.length > 0 && (
          <ProgressionDropdown
            data={progressionDropdownData}
            onChange={progressionDropdownEvents}
          />
        )}
        {excel && (
          <ExportButton
            wordDocData={wordDocData}
            excel={excel}
            downloadId={downloadId}
            downloadIdData={downloadIdData}
            pageHeading={pageHeading}
            studyDetails={studyDetails}
            {...props}
          />
        )}

        {additionalMiddleButton}
        {showObservations && ROLES_CLIENT_SECONDARY.includes(user.UserType) && (
          <Observations insightsElementId={InsightsElementId} {...props} />
        )}

        {(!prismData?.Title) && ((!isFullScreen && pageInsights?.length > 0) || customInsightsData?.length) && (
          <MuiButton
            className='insightsButton active'
            variant='outlined'
            color='gray'
            startIcon={<IconInsights />}
          />
        )}
        {isFullScreen && pageInsights?.length > 0 && <InsightsPopup pageInsights={pageInsights} />}
      </ButtonBox>
    )
  }
}

const InsightsContent = ({ downloadId, pageInsights, resetInsightHeight, onInsightsChange }) => {
  const [btnDetails, setBtnDetails] = useState({ showUp: false, showDown: false, disabled: 'top' })
  const slideContainer = document.getElementById(`reportHeadingRteInsights__${downloadId}__wrapper`)

  const buttonUpFunc = () => {
    const slide = slideContainer.querySelector('.slide')
    const getTop = slide.scrollTop
    if (getTop !== 0) {
      slide.scrollTo({
        top: getTop - 100,
        left: 0,
        behavior: 'smooth',
      })
      setBtnDetails((prev) => ({ ...prev, disabled: '' }))
    } else {
      setBtnDetails((prev) => ({ ...prev, disabled: 'top' }))
    }
  }

  const buttonDownFunc = () => {
    const slide = slideContainer?.querySelector('.slide') || null
    if (isNaN(slide)) {
      const getTop = slide.scrollTop
      const clientHeight = slide.clientHeight
      const scrollHeight = slide.scrollHeight
      if (getTop + clientHeight < scrollHeight) {
        slide.scrollTo({
          top: getTop + 100,
          left: 0,
          behavior: 'smooth',
        })
        setBtnDetails((prev) => ({ ...prev, disabled: '' }))
      } else {
        setBtnDetails((prev) => ({ ...prev, disabled: 'bottom' }))
      }
    }
  }

  const updateHeight = () => {
    const slideContainer =
      document.getElementById(`reportHeadingRteInsights__${downloadId}__wrapper`) || null
    if (isNaN(slideContainer)) {
      slideContainer.style.height = '50px'
      slideContainer.querySelector('.slide').style.height = '50px'
      slideContainer.querySelector('.slideOverlay').style.height = '50px'

      if (slideContainer?.nextSibling?.offsetHeight > 0) {
        const height = slideContainer?.nextSibling?.offsetHeight - 82
        slideContainer.style.height = height + 'px'
        slideContainer.querySelector('.slide').style.height = height + 'px'
        slideContainer.querySelector('.slideOverlay').style.height = height - 65 + 'px'
      }
    }
  }

  const contentDetails = () => {
    const slideContainer =
      document.getElementById(`reportHeadingRteInsights__${downloadId}__wrapper`) || null
    if (isNaN(slideContainer)) {
      const slideContainer = document.getElementById(
        `reportHeadingRteInsights__${downloadId}__wrapper`
      )
      const scrollHeight = slideContainer.querySelector('.slide').scrollHeight
      const show = scrollHeight > slideContainer.offsetHeight
      setBtnDetails((prev) => ({ ...prev, showUp: show, showDown: show }))

      if (slideContainer?.nextSibling?.offsetHeight > 0) {
        const height = slideContainer.nextSibling.offsetHeight - (show ? 82 : 41)
        slideContainer.querySelector('.slide').style.height = height + 'px'
        slideContainer.querySelector('.slideOverlay').style.height = height - 65 + 'px'
      }
    }
  }

  const showInsightsFunc = (type = 'onload') => {
    const wrapperDiv = document.getElementById(
      `reportHeadingRteInsights__${downloadId}__wrapper`
    ).parentNode
    wrapperDiv.classList.add('showRhsInsights')
    if (type !== 'onload') {
      onInsightsChange(type)
    }
    scrollByPxFromCurrentPosition()
  }

  const hideInsightsFunc = () => {
    const wrapperDiv = document.getElementById(
      `reportHeadingRteInsights__${downloadId}__wrapper`
    ).parentNode
    wrapperDiv.classList.toggle('hideRhsInsights')
  }

  const applyStickySlideBarFunc = () => {
    const additionalHt = 71
    const ths = document.getElementById(`reportHeadingRteInsights__${downloadId}__wrapper`) || null
    const mainHeaderHeight =
      document.querySelector('.desktopMenu').getBoundingClientRect().height + additionalHt || 56

    if (
      isNaN(ths) &&
      mainHeaderHeight > 0 &&
      ths?.parentNode?.querySelector('.reportOuterWrapper')
    ) {
      ths.style.removeProperty('height')
      ths.classList.remove('stickySidebar')
      ths.classList.remove('stickySidebarStatic')
      ths.querySelector('.slide').style.removeProperty('height')
      ths.querySelector('.slideOverlay').style.removeProperty('height')
    }

    if (
      isNaN(ths) &&
      mainHeaderHeight > 0 &&
      ths?.parentNode?.querySelector('.reportOuterWrapper')
    ) {
      ths.classList.add('ready')
      const rhsOuterBox = ths
      const rhsInnerBox = ths.querySelector('.slide')
      const rhsOverlay = ths.querySelector('.slideOverlay')
      const lhsOuterBox = ths.parentNode
        .querySelector('.reportOuterWrapper')
        .getBoundingClientRect()
      const windowHeight = window.innerHeight

      rhsOuterBox.style.maxHeight = lhsOuterBox.height + 'px'
      rhsInnerBox.style.maxHeight = lhsOuterBox.height + 'px'
      rhsOverlay.style.maxHeight = lhsOuterBox.height - 65 + 'px'

      if (lhsOuterBox.height > windowHeight) {
        rhsOuterBox.style.maxHeight = windowHeight - mainHeaderHeight + 'px'
        rhsInnerBox.style.maxHeight = windowHeight - mainHeaderHeight + 'px'
        rhsOverlay.style.maxHeight = windowHeight - mainHeaderHeight - 65 + 'px'
        rhsOuterBox.classList.add('stickySidebar')
      } else {
        rhsOuterBox.classList.add('stickySidebarStatic')
        rhsInnerBox.style.height = 'auto'
      }

      const show = rhsInnerBox.scrollHeight > ths.offsetHeight
      setBtnDetails((prev) => ({ ...prev, showUp: show, showDown: show }))
    }
  }

  useEffect(() => {
    showInsightsFunc()
    hideInsightsFunc()
  }, [])

  useEffect(() => {
    applyStickySlideBarFunc()
  }, [resetInsightHeight])

  return (
    <>
      <InsightsOuterWrapper
        className='insightsOuterWrapper stickySidebarDefault'
        id={`reportHeadingRteInsights__${downloadId}__wrapper`}
      >
        <InsightsInnerWrapper className='InsightsInnerWrapper'>
          {!(btnDetails.showUp && btnDetails.showDown) && <ButtonPlaceHolder />}
          {btnDetails.showUp && (
            <ButtonUp className={`${btnDetails.disabled} btn-top-disabled`} onClick={buttonUpFunc}>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M12.0001 10.1078L7.40013 14.7078L6.69238 14L12.0001 8.69226L17.3079 14L16.6001 14.7078L12.0001 10.1078Z'
                  fill='#242424'
                  strokeOpacity={btnDetails.disabled === 'top' ? '0.4' : '1'}
                />
              </svg>
            </ButtonUp>
          )}

          <SlideOverlay className='slideOverlay' />
          <CardRteContent
            className='slide'
            id={`reportHeadingRteInsights__${downloadId}`}
            dangerouslySetInnerHTML={{ __html: pageInsights }}
          ></CardRteContent>

          {btnDetails.showDown && (
            <ButtonDown
              className={`${btnDetails.disabled} btn-bottom-disabled`}
              onClick={buttonDownFunc}
            >
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M12.0001 13.8923L7.40013 9.29225L6.69238 10L12.0001 15.3078L17.3079 10L16.6001 9.29225L12.0001 13.8923Z'
                  fill='#242424'
                  strokeOpacity={btnDetails.disabled === 'top' ? '0.4' : '1'}
                />
              </svg>
            </ButtonDown>
          )}
        </InsightsInnerWrapper>
      </InsightsOuterWrapper>
    </>
  )
}

const InsightsPopup = ({ pageInsights }) => {
  const [showInsightsModal, setShowInsightsModal] = useState(false)
  const handleOnInsights = () => {
    setShowInsightsModal((prev) => !prev)
  }

  return (
    <>
      <MuiButton
        variant='outlined'
        color='light'
        onClick={() => setShowInsightsModal(true)}
        className={showInsightsModal ? 'active' : ''}
        startIcon={<IconInsights />}
      />

      {showInsightsModal && (
        <MenuOuterWrapper open={showInsightsModal} onClose={handleOnInsights}>
          <MenuHeading>Insights</MenuHeading>
          <MuiButton
            variant='text'
            color='light'
            startIcon={<IconClose />}
            onClick={() => setShowInsightsModal(false)}
            className='insightsCloseButton'
          />
          <MenuInnerWrapper>
            <CardRteContent dangerouslySetInnerHTML={{ __html: pageInsights }}></CardRteContent>
          </MenuInnerWrapper>
        </MenuOuterWrapper>
      )}
    </>
  )
}

InsightsPopup.propTypes = {
  pageInsights: PropTypes.string,
}

const ArrowLeft = ({ onClick, className }) => {
  return (
    <MenuIconButton size='small' onClick={onClick} className={className}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='10'
        height='11'
        viewBox='0 0 10 11'
        fill='none'
      >
        <path d='M9 1L5 5.5L9 10' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M5 1L1 5.5L5 10' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
      </svg>
    </MenuIconButton>
  )
}